import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
export function WearHausWay() {
  const infoPages = [{
    name: 'FAQs',
    path: '/helpful-info/faqs'
  }, {
    name: 'Compliance',
    path: '/helpful-info/compliance'
  }, {
    name: 'Screen Printing Advice',
    path: '/helpful-info/screen-printing-advice'
  }, {
    name: 'What is Vector Art?',
    path: '/helpful-info/vector-art'
  }, {
    name: 'The Wear Haus Way',
    path: '/helpful-info/wear-haus-way'
  }, {
    name: 'Terms and Conditions',
    path: '/helpful-info/terms-and-conditions'
  }, {
    name: 'Privacy Policy',
    path: '/helpful-info/privacy-policy'
  }];
  return <div className="flex flex-col w-full" data-id="element-896">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-pink to-pink-600 py-16" data-id="element-897">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-898">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-899">
            The Wear Haus Way
          </h1>
          <p className="text-xl text-white/90" data-id="element-900">Our Philosophy and Approach</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50" data-id="element-901">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-902">
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-903">
            {/* Sidebar Navigation */}
            <aside className="lg:w-64 flex-shrink-0" data-id="element-904">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-24" data-id="element-905">
                <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-906">
                  Helpful Info
                </h3>
                <nav className="space-y-2" data-id="element-907">
                  {infoPages.map(page => <Link key={page.path} to={page.path} className={`block px-3 py-2 rounded-md text-sm font-medium transition-colors ${page.path === '/helpful-info/wear-haus-way' ? 'bg-wh-pink text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-908">
                      {page.name}
                    </Link>)}
                </nav>
              </div>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1" data-id="element-909">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-910">
                <div className="prose prose-lg max-w-none text-gray-700" data-id="element-911">
                  {/* Introduction */}
                  <div className="mb-12 space-y-6" data-id="element-912">
                    <p className="text-lg leading-relaxed" data-id="element-913">
                      At Wear Haus Designs we place a lot of value on the
                      opinions and voices of our customers. After all, we're
                      here because of you! We frequently receive and implement
                      feedback to achieve the highest level of customer
                      satisfaction possible.
                    </p>
                    <p className="text-lg leading-relaxed" data-id="element-914">
                      When it comes to garment decorating, not all companies are
                      created equal. Shops come in all types and sizes and
                      finding a great one can be harder than you think. From
                      inexperienced "garage shops" with one manual press to
                      experienced "industry shops" with 1000-shirt minimums,
                      quality and price run the gamut.
                    </p>
                    <p className="text-lg leading-relaxed font-medium text-gray-900" data-id="element-915">
                      So what does that mean when it applies to Wear Haus?
                      Whether you need one garment or 10,000, we work to get you
                      the highest quality workmanship at a fair price.
                    </p>
                  </div>

                  {/* Inks Section */}
                  <div className="mb-16" data-id="element-916">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-917">
                      Inks
                    </h3>
                    <p className="text-lg leading-relaxed" data-id="element-918">
                      We feature top quality inks from companies like Rutland,
                      One Stroke, and Wilflex. Industry-leading inks utilized
                      with the utmost care and attention to detail. Our expert
                      printing team selects the best inks for each project.
                    </p>
                  </div>

                  {/* Equipment Section */}
                  <div className="mb-16" data-id="element-919">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-920">
                      Equipment
                    </h3>
                    <div className="space-y-6" data-id="element-921">
                      <p className="text-lg leading-relaxed" data-id="element-922">
                        Our screen printing department features machinery
                        produced by the #1 screen print manufacturing company in
                        the world (
                        <a href="https://www.mrprint.com/" target="_blank" rel="noopener noreferrer" className="text-wh-pink hover:text-pink-700 underline" data-id="element-923">
                          M&R
                        </a>
                        ). Wear Haus uses top-end automatic presses allowing us
                        to print thousands of shirts with tight registration
                        swiftly and efficiently. Many smaller shops use manual
                        hand presses that are great for small orders but lack
                        consistency and often times struggle with registration
                        on more complex jobs. Automatic presses enable us to
                        print higher volume, lowering the cost of printing on
                        larger orders.
                      </p>
                      <p className="text-lg leading-relaxed" data-id="element-924">
                        We utilize some of the most reliable and accurate
                        embroidery machines available. We are currently capable
                        of embroidering 23 garments at once, or up to 5 separate
                        designs at once. Our machines are fast, with most orders
                        being completed within days instead of weeks.
                      </p>
                    </div>
                  </div>

                  {/* Screens Section */}
                  <div className="mb-16" data-id="element-925">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-926">
                      Screens
                    </h3>
                    <p className="text-lg leading-relaxed" data-id="element-927">
                      Screens vary widely from frames to mesh. Cheap screens can
                      hurt quality with prints not lining up and/or loss of
                      detail. It's also very important to know and understand
                      that not all screens are the same. Different inks require
                      different screens and the tension of those screens will
                      affect how the print comes out. At Wear Haus, we've spent
                      a lot of time and effort researching what screens and
                      processes are going to deliver you the best quality
                      product possible.
                    </p>
                  </div>

                  {/* Artwork Proofs/Approvals Section */}
                  <div className="mb-16" data-id="element-928">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-929">
                      Artwork Proofs/Approvals
                    </h3>
                    <div className="space-y-6 mb-10" data-id="element-930">
                      <p className="text-lg leading-relaxed" data-id="element-931">
                        If you know anything about textile decoration, you know
                        a lot can go wrong. If you don't know much about textile
                        decoration, the sheer thought of this can be pretty
                        scary. It's important to feel good about your order and
                        have a realistic grasp on what your items will look like
                        when they arrive to you.
                      </p>
                      <p className="text-lg leading-relaxed" data-id="element-932">
                        Once your order is submitted and paid for, our graphic
                        designers prepare digital artwork proofs showing what
                        the artwork looks like on your chosen item (in most
                        cases). After your review, we correct any changes before
                        production begins.
                      </p>
                    </div>

                    {/* Proof Examples */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start" data-id="element-933">
                      {/* Screen Print Proof */}
                      <div className="flex flex-col items-center" data-id="element-934">
                        <h4 className="text-lg font-bold text-gray-800 mb-4 text-center" data-id="element-935">
                          Example screen print art proof
                        </h4>
                        <div className="bg-gray-50 p-4 rounded-lg shadow-sm border border-gray-100 w-full flex justify-center" data-id="element-936">
                          <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesign%2FProof_example-1-400x298.png&site=11804&w=400&h=298&user=6074&opt=w3" alt="Example screen print art proof showing design placement on garment" className="max-w-full h-auto rounded" loading="lazy" data-id="element-937" />
                        </div>
                      </div>

                      {/* Embroidery Proofs */}
                      <div className="flex flex-col items-center" data-id="element-938">
                        <h4 className="text-lg font-bold text-gray-800 mb-4 text-center" data-id="element-939">
                          Example embroidery art proofs
                        </h4>
                        <div className="grid grid-cols-2 gap-4 w-full" data-id="element-940">
                          <div className="bg-gray-50 p-2 rounded-lg shadow-sm border border-gray-100 flex justify-center" data-id="element-941">
                            <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesign%2FBitmap-in-Emailed-Embroidery-Proof.cdr_-600x776.jpg&site=11804&w=250&h=323&user=6074&opt=w3" alt="Emailed embroidery proof example" className="max-w-full h-auto rounded" loading="lazy" data-id="element-942" />
                          </div>
                          <div className="bg-gray-50 p-2 rounded-lg shadow-sm border border-gray-100 flex justify-center" data-id="element-943">
                            <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesign%2FBitmap-in-Faxed-Embroidery-Proof.cdr_-600x776.jpg&site=11804&w=250&h=323&user=6074&opt=w3" alt="Faxed embroidery proof example" className="max-w-full h-auto rounded" loading="lazy" data-id="element-944" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Closing Section */}
                  <div className="bg-gray-50 p-8 rounded-xl border border-gray-100 text-center" data-id="element-945">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-946">
                      Your Orders Are Important to Us
                    </h3>
                    <p className="text-lg text-gray-700 mb-6" data-id="element-947">
                      Please feel free to reach out with any questions.
                    </p>
                    <Link to="/contact" className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-wh-pink hover:bg-pink-700 transition-colors shadow-sm" data-id="element-948">
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </section>
    </div>;
}